import Links from '@/shared/constants/navegacao';
import { Fragment, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { requestPasswordRecoveryCode } from '../../application/auth.service';
import { useNavigate } from 'react-router-dom';

export default function RecuperarIndex() {
  const navigate = useNavigate();
  const email = useRef<HTMLInputElement>(null);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (email.current?.value)
      requestPasswordRecoveryCode(email.current?.value)
        .then((res) => {
          toast.info(res.data + ' E-mail enviado, verifique sua caixa de entrada.');
          setTimeout(() => navigate(`${Links.TrocarSenha}`), 5000);
        }).catch((error) => {
          toast.error(String(error));
        });
  };

  return (
    <Fragment>
      <ToastContainer position="top-center" />
      <section className="ftco-section">
        <div className="loginrow w-100 justify-content-center">
          <div
            className=""
            style={{ width: '35%', minWidth: '25%', maxWidth: '40%' }}
          >
            <div className="d-flex">
              <div className="w-100">
                <h4 className="mb-4">Recuperação de senha</h4>
              </div>
            </div>
            <form className="signin-form" onSubmit={handleSubmit}>
              <div className="loginform-group">
                <label className="loginlabel" htmlFor="email">
                  E-mail
                </label>
                <input
                  ref={email}
                  title="E-mail para recuperação"
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  className="form-control"
                  required
                />
              </div>
              <div className="loginform-group">
                <button
                  type="submit"
                  className="form-control loginbtn loginbtn-primary submit px-3"
                >
                  Recuperar
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </Fragment>
  );
}
